<template>
  <modal
    ref="modal"
    width="100%"
    height="100%"
    name="bike-add"
    class="slide-modal"
    overlay-transition="slide-modal-overlay"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="$modal.hide('bike-add')">
      <span class="icon">
        <img
          src="~/assets/images/icons/Close-button.svg"
          class="icon alt"
          alt="close icon"
        />
      </span>
    </div>
    <div class="slide-modal-container">
      <BikeAdd />
    </div>
  </modal>
</template>

<script>
import BikeAdd from '@/components/BikeAdd'
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/scrollLock'
export default {
  name: 'BikeAddModal',
  components: { BikeAdd },
  watch: {
    // Closing on navigation is what releases the body lock.
    $route() {
      this.$modal.hide('bike-add')
    },
  },
  beforeDestroy() {
    unlockBodyScroll({ restoreScroll: false })
  },
  methods: {
    beforeOpen(event) {
      lockBodyScroll()
    },
    beforeClose(event) {
      unlockBodyScroll()
    },
  },
}
</script>
